import { IState } from '../store';

export const selectBannerRotation = (state: IState) => state.bannerRotation;
